import { OrganizationUnitDetailDto, OrganizationUnitDto, OrganizationUnitProfileDto, OrganizationUnitTreeNodeDto } from '../services/organization-unit-api.service';
import { OrganizationUnit } from '../../../features/units/models/unit.model';

/**
 * Convierte un OrganizationUnitDto (o TreeNodeDto) generado por NSwag
 * al tipo de dominio OrganizationUnit usado por los features.
 *
 * Centraliza todos los `?? ''` / `?? 0` para que un cambio en el contrato
 * de la API solo requiera tocar este archivo.
 */
export function mapOrganizationUnit(
  dto: OrganizationUnitDto | OrganizationUnitTreeNodeDto
): OrganizationUnit {
  const treeDto = dto as OrganizationUnitTreeNodeDto;
  const regionalChurch = dto as OrganizationUnitProfileDto;
  return {
    id: dto.id ?? '',
    name: dto.name ?? '',
    photo: (dto as OrganizationUnitDto).photoUrl ?? undefined,
    shortName: dto.shortName ?? '',
    costCentre: dto.costCentre ?? undefined,
    description: (dto as OrganizationUnitDto).description ?? undefined,
    parentUnitId: dto.parentUnitId ?? undefined,
    regionalChurchId: regionalChurch.regionalChurchId ?? undefined,
    regionalChurchName: regionalChurch.regionalChurchName ?? undefined,
    areaId: (dto as OrganizationUnitDto).areaId ?? undefined,
    areaName: (dto as OrganizationUnitDto).areaName ?? undefined,
    districtId: (dto as OrganizationUnitDto).districtId ?? undefined,
    districtName: (dto as OrganizationUnitDto).districtName ?? undefined,
    organizationLevelId: (dto.organizationLevelId ?? 1) as OrganizationUnit['organizationLevelId'],
    levelName: dto.levelName ?? '',
    leaderId: (dto as OrganizationUnitDto).leaderId ?? undefined,
    leader: dto.leader ?? undefined,
    leaderMinistryName: dto.leaderMinistryName ?? undefined,
    leaderAppointmentName: ((dto as OrganizationUnitDto & { leaderAppointmentName?: string }).leaderAppointmentName) ?? undefined,
    leaderPhone: (dto as OrganizationUnitDto).leaderPhone ?? undefined,
    children: treeDto.children?.length
      ? treeDto.children.map(child => mapOrganizationUnit(child))
      : undefined,
    detail: mapOrganizationUnitDetail((dto as OrganizationUnitDto).detail),
  };
}

function mapOrganizationUnitDetail(dto: OrganizationUnitDetailDto | undefined) {
  if (!dto) return undefined;
  return {
    organizationUnitId: dto.organizationUnitId ?? '',
    addressLine: dto.addressLine,
    city: dto.city,
    department: dto.department,
    province: dto.province,
    countryId: dto.countryId,
    countryName: dto.countryName,
    postalCode: dto.postalCode,
    latitude: dto.latitude,
    longitude: dto.longitude,
    additionalInfo: dto.additionalInfo,
  };
}
